import { make } from 'vuex-pathify'

const state = {
  display: false,
  type: 'success', // 'success', 'info', 'warning', 'error'
  message: null,
  status_code: null,
  errors: {}
}

const mutations = {
  SET_ALERT(state, payload) {
    state.display = payload.display || false
    state.type = payload.type || null
    state.message = payload.message || null
    state.status_code = payload.status_code || null
    state.errors = payload.errors || {}
  },
  SET_DISPLAY(state, status) {
    state.display = status
  }
}

const actions = {
  error({ commit }, payload) {
    commit('SET_ALERT', {
      ...payload,
      type: 'error',
      display: true
    })
  },

  success({ commit }, payload) {
    commit('SET_ALERT', {
      ...payload,
      type: 'success',
      display: true
    })
  },

  reset({ commit }) {
    commit('SET_ALERT', {})
  },

  hide({ commit }) {
    commit('SET_DISPLAY', false)
  },

  show({ commit }) {
    commit('SET_DISPLAY', true)
  }
}

const getters = make.getters(state)

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
